export const missouri = {
  "29000": "Missouri",
  "29001": "Adair County",
  "29003": "Andrew County",
  "29005": "Atchison County",
  "29007": "Audrain County",
  "29009": "Barry County",
  "29011": "Barton County",
  "29013": "Bates County",
  "29015": "Benton County",
  "29017": "Bollinger County",
  "29019": "Boone County",
  "29021": "Buchanan County",
  "29023": "Butler County",
  "29025": "Caldwell County",
  "29027": "Callaway County",
  "29029": "Camden County",
  "29031": "Cape Girardeau County",
  "29033": "Carroll County",
  "29035": "Carter County",
  "29037": "Cass County",
  "29039": "Cedar County",
  "29041": "Chariton County",
  "29043": "Christian County",
  "29045": "Clark County",
  "29047": "Clay County",
  "29049": "Clinton County",
  "29051": "Cole County",
  "29053": "Cooper County",
  "29055": "Crawford County",
  "29057": "Dade County",
  "29059": "Dallas County",
  "29061": "Daviess County",
  "29063": "DeKalb County",
  "29065": "Dent County",
  "29067": "Douglas County",
  "29069": "Dunklin County",
  "29071": "Franklin County",
  "29073": "Gasconade County",
  "29075": "Gentry County",
  "29077": "Greene County",
  "29079": "Grundy County",
  "29081": "Harrison County",
  "29083": "Henry County",
  "29085": "Hickory County",
  "29087": "Holt County",
  "29089": "Howard County",
  "29091": "Howell County",
  "29093": "Iron County",
  "29095": "Jackson County",
  "29097": "Jasper County",
  "29099": "Jefferson County",
  "29101": "Johnson County",
  "29103": "Knox County",
  "29105": "Laclede County",
  "29107": "Lafayette County",
  "29109": "Lawrence County",
  "29111": "Lewis County",
  "29113": "Lincoln County",
  "29115": "Linn County",
  "29117": "Livingston County",
  "29119": "McDonald County",
  "29121": "Macon County",
  "29123": "Madison County",
  "29125": "Maries County",
  "29127": "Marion County",
  "29129": "Mercer County",
  "29131": "Miller County",
  "29133": "Mississippi County",
  "29135": "Moniteau County",
  "29137": "Monroe County",
  "29139": "Montgomery County",
  "29141": "Morgan County",
  "29143": "New Madrid County",
  "29145": "Newton County",
  "29147": "Nodaway County",
  "29149": "Oregon County",
  "29151": "Osage County",
  "29153": "Ozark County",
  "29155": "Pemiscot County",
  "29157": "Perry County",
  "29159": "Pettis County",
  "29161": "Phelps County",
  "29163": "Pike County",
  "29165": "Platte County",
  "29167": "Polk County",
  "29169": "Pulaski County",
  "29171": "Putnam County",
  "29173": "Ralls County",
  "29175": "Randolph County",
  "29177": "Ray County",
  "29179": "Reynolds County",
  "29181": "Ripley County",
  "29183": "St. Charles County",
  "29185": "St. Clair County",
  "29186": "Ste. Genevieve County",
  "29187": "St. Francois County",
  "29189": "St. Louis County",
  "29195": "Saline County",
  "29197": "Schuyler County",
  "29199": "Scotland County",
  "29201": "Scott County",
  "29203": "Shannon County",
  "29205": "Shelby County",
  "29207": "Stoddard County",
  "29209": "Stone County",
  "29211": "Sullivan County",
  "29213": "Taney County",
  "29215": "Texas County",
  "29217": "Vernon County",
  "29219": "Warren County",
  "29221": "Washington County",
  "29223": "Wayne County",
  "29225": "Webster County",
  "29227": "Worth County",
  "29229": "Wright County",
  "29510": "St. Louis city",
};
